// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__QAmdS","detailsBorder":"styles_detailsBorder__2qZXP"};